import { Injectable } from '@angular/core';
import { Http,Response , Headers } from '@angular/http';

import { Config } from '../../config/config';
import { VnptHttpService } from '../services/vnpt-http.service';
import { Observable }     from 'rxjs/Observable';
import { DMDonViXuLy,SearchDMDonViXuLy } from './dm-don-vi-xu-ly';
@Injectable()
export class DMDonViXuLyService {
    controller:string = 'DMDonViXuLy';
    constructor(private http: Http) { }
   
   
    GetList(IdCoQuan:number) {
        let headers = new Headers();       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {IdCoQuan:IdCoQuan};
        return this.http.post(Config.apiUrl + this.controller+'/GetList', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
               
    }

    GetListFromPagination(IdCoQuan:number,paging:number,maxSize:number, keyword: string) {
        let headers = new Headers();
        let currentPage = paging - 1;
       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +this.controller+ '/GetListPagination?IdCoQuan=' + IdCoQuan + "&currentPage="+ currentPage+"&maxSize="+ maxSize + "&keyword=" + keyword, { headers: headers }).map(resp => resp.json());       
    }

    GetItem(id:number) {
        let headers = new Headers();
       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {Id:id};
        return this.http.post(Config.apiUrl + this.controller+'/GetItem/'+id, JSON.stringify(data), { headers: headers }).map(resp => resp.json());
               
    }

    Save(item:DMDonViXuLy) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + this.controller+'/save', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
  
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/dm-don-vi-xu-ly/dm-don-vi-xu-ly.service.ts